import { User } from '../models/user';
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpErrorResponse,
  HttpParams,
  HttpHeaders,
} from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { ErrorResource } from './error.resource';
import { Operation } from '../models/operation';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthResource {
  protected url = environment;
  protected unpaginated: boolean = false;
  protected params: HttpParams = new HttpParams();

  constructor(
    private http: HttpClient,
    private errorResource: ErrorResource
  ) {}

  login(username: string, password: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Client-Id': this.url.CLIENT_ID,
    });
    const body = {
      email: username,
      password: password,
    };
    return this.http
      .post(this.url.SERVER_URL + 'login', body, { headers: headers })
      .pipe(
        map((res: unknown) => res['data']),
        catchError(err => this.handleError(err))
      );
  }

  me(token) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    });
    const options = token ? { headers: headers } : {};
    return this.http.get(this.url.SERVER_URL + 'me', options).pipe(
      map((res: unknown) => {
        return this.map(res['data'], token);
      }),
      catchError(err => this.handleError(err))
    );
  }

  operationMe(user, operation) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Operation-Id': operation.id + '',
      Authorization: 'Bearer ' + user.token,
    });
    return this.http
      .get(this.url.SERVICE_URL + 'me', { headers: headers })
      .pipe(map((res: unknown) => res['data']));
  }

  getOperations(user: User) {
    const token = user.token;
    const params = this.unpaginated
      ? this.params.append('unpaginated', '')
      : this.params;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
      'Client-Id': this.url.CLIENT_ID,
    });
    const options = token ? { headers: headers, params: params } : {};
    return this.http
      .get(this.url.SERVER_URL + 'users/' + user.id + '/operations', options)
      .pipe(
        map((res: unknown) => this.mapOperations(res)),
        catchError(err => this.handleError(err))
      );
  }

  editProfile(user: User, data: unknown) {
    const token = user.token;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    });
    const options = token ? { headers: headers } : {};
    return this.http.post(this.url.SERVICE_URL + 'profile', data, options).pipe(
      map((res: unknown) => this.map(res['data'], user.token)),
      catchError(err => this.handleError(err))
    );
  }

  changePassword(user: User, data: unknown) {
    const token = user.token;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
      'Client-Id': this.url.CLIENT_ID,
    });
    const options = token ? { headers: headers } : {};
    return this.http
      .put(this.url.SERVER_URL + 'changePassword', data, options)
      .pipe(
        map((res: unknown) => res['data']),
        catchError(err => this.handleError(err))
      );
  }

  rememberPassword(data) {
    const headers = new HttpHeaders({
      'Client-Id': this.url.CLIENT_ID,
    });
    return this.http
      .post(this.url.SERVER_URL + 'forgot', data, {
        headers: headers,
      })
      .pipe(catchError(err => this.handleError(err)));
  }

  private map(data, token = null) {
    if (token) {
      data.token = token;
    }
    return new User(data);
  }

  private mapOperations(data) {
    const arr: Operation[] = [];
    data.data.forEach(e => {
      arr.push(new Operation(e));
    });
    return arr;
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    }

    return throwError(error);
  }

  unpaginate(unpaginated = true) {
    this.unpaginated = unpaginated;
  }
}
